import { create } from "zustand";
// Define the store state type

export type ChatFilters = {
    filter: {
        search: string;
    };
    limit: number;
};
export interface ChatState {
    filters: ChatFilters;

    sendMessageParams: {
        web: boolean;
    };

    modelId: string;

    setModelId: (modelId: string) => void;

    clearFilters: () => void;

    setFilters: (filters: ChatState["filters"]) => void;

    setSearch: (search: string) => void;

    setWeb: (web: boolean) => void;
}

// Create the Zustand store
export const useChatStore = create<ChatState>()((set) => ({
    filters: {
        filter: {
            search: "",
        },
        limit: 30,
    },

    sendMessageParams: {
        web: false,
    },

    modelId: "",

    setModelId: (modelId) => set({ modelId }),

    setFilters: (filters) => {
        set({ filters });
    },

    clearFilters: () => set({ filters: { filter: { search: "" }, limit: 30 } }),

    setSearch: (search) => set(({ filters }) => ({ filters: { ...filters, filter: { ...filters.filter, search } } })),

    setWeb: (web) => set(({ sendMessageParams }) => ({ sendMessageParams: { ...sendMessageParams, web } })),
}));
